import { FC, useContext, useMemo } from "react";
import { AppContext } from "../../App";
import { Logo } from "../commons";

export const About: FC = () => {
  const { userInfo, lang } = useContext(AppContext);

  const array = userInfo ? userInfo.mainText.split("'") : [];

  const linkToCV = useMemo(() => {
    switch (lang) {
      case "en":
        return "https://sunny-yeot-584d1a.netlify.app/Sofiia_Shevtsova_CV.pdf";
      case "pl":
        return "https://sunny-yeot-584d1a.netlify.app/Sofiia_Shevtsova_CV_PL.pdf";
      default:
        return "https://sunny-yeot-584d1a.netlify.app/Sofiia_Shevtsova.pdf";
    }
  }, [lang]);

  if (userInfo) {
    return (
      <section id={userInfo.navigation[0][1]}>
        <h1 className="hidden">{userInfo.name}</h1>
        <div className="name">
          <p>
            {array[0]}
            <span>{array[1] ? "'" : null}</span>
            {array[1]}
          </p>
          <p>
            {userInfo.name}
            <span>.</span>
          </p>
        </div>
        <p className="position">{userInfo.work}</p>
        <div className="information">
          <Logo />
          <div className="about-me">
            <p>{userInfo.phrase}</p>
            <p>{userInfo.aboutMe}</p>
            <p>{userInfo.textForCV} &#128521;</p>
          </div>
          <a className="download" href={linkToCV} download>
            {userInfo.downloadBtn}
          </a>
        </div>
      </section>
    );
  } else {
    return null;
  }
};
